import Phaser from 'phaser';
import { supabase } from '@/config/supabase';
import { SaveManager } from '@/systems/SaveManager';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Boot' });
  }

  async create(): Promise<void> {
    const { width, height } = this.scale;

    const statusText = this.add
      .text(width / 2, height / 2, 'Connecting...', {
        fontSize: '16px', color: '#888', fontFamily: 'monospace',
      })
      .setOrigin(0.5);

    const { data: { session } } = await supabase.auth.getSession();

    if (session?.user) {
      statusText.setText('Loading save...');
      const saveManager = new SaveManager();
      saveManager.setPlayerId(session.user.id);
      const state = await saveManager.load();

      if (!state) {
        const username = 'Archon_' + session.user.id.slice(0, 6);
        await saveManager.createPlayer(session.user.id, username);
      }

      this.scene.start('Kingdom', {
        userId: session.user.id,
        savedState: state,
      });
    } else {
      statusText.setText('Creating session...');
      const { data, error } = await supabase.auth.signInAnonymously();
      if (error || !data.user) {
        statusText.setText('Error: ' + (error?.message ?? 'unknown'));
        return;
      }
      const saveManager = new SaveManager();
      saveManager.setPlayerId(data.user.id);
      const username = 'Archon_' + data.user.id.slice(0, 6);
      await saveManager.createPlayer(data.user.id, username);

      this.scene.start('Kingdom', {
        userId: data.user.id,
        savedState: null,
      });
    }
  }
}
